import { render, staticRenderFns } from "./DraftCases.vue?vue&type=template&id=1d4f7b82&scoped=true"
import script from "./DraftCases.vue?vue&type=script&lang=js"
export * from "./DraftCases.vue?vue&type=script&lang=js"
import style0 from "./DraftCases.vue?vue&type=style&index=0&id=1d4f7b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4f7b82",
  null
  
)

export default component.exports